import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../../features/user/userSlice";
import { formatNumber } from "../../../utils/tools";
import { Button, ButtonsContainerRetiro, ErrorSpan, Form, InputContainer } from "../DepositElements";
import tupaypasarelas from '../../../assets/images/tupayretiros2.png';
import Rtupay from '../../../assets/images/RETITUPAY.svg';

const FormTuPay = ({
  form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  return (
    <Form>

      <InputContainer>
        <label>TIPO DE DOCUMENTO:</label>
        <select value={form.documentType} onChange={handleChange} name='documentType' >
          <option disabled value=''>TIPO DE DOCUMENTO</option>
          <option value='RUC'>RUC</option>
          <option value='CE'>CE</option>
          <option value='DNI'>DNI</option>
          <option value='PASS'>PASS</option>
        </select>
      </InputContainer>

      <InputContainer>
          <label>{t('deposit.id')}:</label>
          <input type='text' placeholder={t('deposit.id')} name='cedula' value={form.cedula} onChange={handleChange} />
        </InputContainer>

      <InputContainer>
        <label>{t("deposit.Interbank-account-number(CCI)")}:</label>
        <input type='text' placeholder={t("deposit.Interbank-account-number(CCI)")} name='numeroCuenta' value={form.numeroCuenta} onChange={handleChange} />
      </InputContainer>

      <InputContainer>
          <label>{t("deposit.account-type")}:</label>
          <select value={form.tipoCuenta} onChange={handleChange} name='tipoCuenta' >
            <option disabled value=''>{t("deposit.select-account-type")}</option>
              <option value='S'>Cuenta Ahorro</option>
              <option value='C'>Cuenta Corriente</option>
          </select>
        </InputContainer>

      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto"
          value={form.monto}
          onChange={(e) => handleMonto(e)}
        />
        {monto < 50 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 50 {moneda}{" "}
          </ErrorSpan>
        )}
      </InputContainer>
      <img src={Rtupay} alt='Tupay' className={'tupa3'} style={{width:'40%', marginLeft: '30%', marginTop: '5%'}}/>
      <img src={tupaypasarelas} alt='Pasarelas Tupay' className={'tupa4'} style={{width:'120%', marginTop: '1%', marginLeft: '-10%'}}/>
      <ButtonsContainerRetiro style={{marginTop:'-160px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button
          primary={true}
          disabled={loading || monto < 50}
          onClick={solicitarRetiro}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainerRetiro>
    </Form>
  );
};

export default FormTuPay;
